import { jsx as s, jsxs as _ } from "react/jsx-runtime";
import { useRef as C, createElement as x } from "react";
import b from "reactjs-popup";
import h from "classnames";
import k from "./icons/ArrowRightBold.js";
const v = "forma-ui__context-menu-item__item", g = "forma-ui__context-menu-item__active", y = "forma-ui__context-menu-item__disabled", N = "forma-ui__context-menu-item__icon", M = "forma-ui__context-menu-item__iconChecked", o = {
  item: v,
  active: g,
  disabled: y,
  icon: N,
  iconChecked: M
}, I = (r) => {
  const { href: m, to: l, as: a = "button", text: n, icon: u, items: i, disabled: d, onClick: f, onMouseEnter: c, onMouseLeave: t } = r;
  return i ? /* @__PURE__ */ s(
    E,
    {
      control: (e) => /* @__PURE__ */ _(
        "button",
        {
          className: h(o.item, e && o.active),
          onMouseEnter: c,
          onMouseLeave: t,
          children: [
            n,
            " ",
            /* @__PURE__ */ s(k, { className: o.icon })
          ]
        }
      ),
      on: ["hover", "focus"],
      items: i,
      position: ["right center", "left center", "right bottom", "left bottom"],
      mouseLeaveDelay: 200,
      offsetX: 12
    }
  ) : /* @__PURE__ */ _(
    a,
    {
      to: l,
      href: m,
      className: h(o.item, d && o.disabled),
      onClick: f,
      onMouseEnter: c,
      onMouseLeave: t,
      children: [
        n,
        " ",
        u
      ]
    }
  );
}, j = "forma-ui__context-menu__list", w = {
  list: j
}, E = ({
  open: r,
  control: m,
  items: l,
  mouseLeaveDelay: a,
  offsetX: n = 0,
  offsetY: u = 0,
  onOpen: i,
  onClose: d,
  on: f = ["click"],
  position: c = ["bottom left", "top left", "bottom right", "top right"]
}) => {
  const t = C(null);
  return /* @__PURE__ */ s(
    b,
    {
      on: f,
      open: r,
      trigger: m,
      className: "options",
      position: c,
      arrow: !1,
      offsetY: u,
      offsetX: n,
      onOpen: i,
      onClose: d,
      mouseLeaveDelay: a,
      ref: t,
      nested: !0,
      children: /* @__PURE__ */ _("div", { className: w.list, children: [
        /* @__PURE__ */ s("input", { type: "hidden", style: { display: "none" }, autoFocus: !0 }),
        l.map((e, p) => /* @__PURE__ */ x(I, { ...e, onClick: () => {
          e.onClick && e.onClick(), t.current && t.current.close();
        }, key: p }))
      ] })
    }
  );
};
export {
  E as C,
  I as a
};
